<template>
  <div v-if="selected.length > 0">
    <button class="button button--glc-gold button--block mb-3 fake-select__unselect-button"
            v-for="option in selected" @click.prevent>
      {{ option.label }}
      <span @click="selected = selected.filter(o => o !== option); emit('update:modelValue', selected)"
            class="fake-select__unselect">
        <i class="fa-thin fa-xmark"></i>
      </span>
    </button>
  </div>

  <div class="fake-select" :class="{open: opened}" ref="root">
    <div class="fake-select__placeholder" @click="opened=!opened">
      <span v-if="selected.length === 0">{{ placeholder }}</span>
      <span v-if="selected.length > 0">{{ selectedPlaceholder }}</span>
      <i class="fa-solid fa-angle-down ms-3" v-if="!opened"></i>
      <i class="fa-solid fa-angle-up ms-3" v-if="opened"></i>
    </div>
    <div class="fake-select__options" v-if="opened">
      <div v-for="option in options">
        <div class="fake-select__option" @click="add(option)" v-if="!selected.includes(option)">
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {ref, watch, onMounted, onUnmounted} from 'vue'

const props = defineProps({
  modelValue: Array,
  placeholder: String,
  selectedPlaceholder: String,
  options: Array,  // -> [{value: String, label: String}, ...]
})

const emit = defineEmits(['update:modelValue'])
const root = ref(null)
const opened = ref(false)
const selected = ref([]);

watch(() => props.modelValue, (value) => {
  selected.value = value
}, {immediate: true})

const add = (option) => {
  selected.value.push(option)
  opened.value = false
  emit('update:modelValue', selected.value)
}


onMounted(() => {
  const close = (event) => {
    const closest = event.target.closest('.fake-select');
    if (!closest || closest !== root.value) {
      opened.value = false
    }
  }

  document.addEventListener('click', close)
  onUnmounted(() => document.removeEventListener('click', close))
})


</script>
